import React from 'react';
import { Tooltip } from 'antd';
import { number_format, sortAtoZ } from '@utils/widget';

const tooltipCellRender = (text) =>
  text ? <Tooltip title={text}>{text}</Tooltip> : '-';

// const filterIcon = (active) => (
//   <span
//     // className={`appkiticon icon-filter-outline ${active ? 'active' : ''}`}
//     className="appkiticon icon-filter-outline active"
//   />
// );

export const checkIcon = (item) =>
  item ? <span className="appkiticon icon-check-mark-fill a-font-10 " /> : '';
export const defaultColumns = [
  {
    title: (
      <div style={{ display: 'flex', alignItem: 'center' }}>
        <Tooltip title={<>Legal Entity</>} placement="bottomRight">
          Legal Entity
        </Tooltip>
        <Tooltip
          title={
            <div className="subs-table-tooltip-icon">
              <div>
                <span className="appkiticon icon-radio-outline a-font-10 a-text-orange" />
                Subsidiary
              </div>
              <div>
                <span className="appkiticon icon-radio-fill a-font-10 a-text-orange" />
                Principal Subsidiary
              </div>
            </div>
          }
          placement="right"
        >
          <span className="appkiticon  a-font-12 ml-5 icon-information-fill" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'companyName',
    key: 'companyName',
    className: 'collapse-company',
    ellipsis: true,
    width: '400',
    align: 'left',
    sorter: (a, b) => sortAtoZ(a?.companyName, b?.companyName),

    render: (text, record, index) => {
      const { type, companyName } = record;
      const hasChildren = record.children && record.children.length !== 0;
      return (
        <Tooltip title={companyName} placement="topLeft">
          {type === 'Subsidiary' && (
            <span
              className="appkiticon icon-radio-outline a-font-10 a-text-orange"
              style={{ margin: '0px 6px', opacity: hasChildren ? 1 : 0 }}
            />
          )}
          {type === 'Principal Subsidiary' && (
            <span
              className="appkiticon icon-radio-fill a-font-10 a-text-orange"
              style={{ margin: '0px 6px', opacity: hasChildren ? 1 : 0 }}
            />
          )}
          {companyName}
        </Tooltip>
      );
    },
  },
  {
    title: (
      <Tooltip title={<>LOC</>} placement="bottomRight">
        <div>
          <span
            className="appkiticon icon-location-fill"
            style={{ marginRight: '0.313rem' }}
          />
          LOC
        </div>
      </Tooltip>
    ),
    dataIndex: 'loc',
    key: 'loc',
    width: '300',
    render: tooltipCellRender,
    sorter: (a, b) => sortAtoZ(a.loc, b.loc),
  },
  {
    title: (
      <Tooltip title={<>Employees</>} placement="bottomRight">
        Employees
      </Tooltip>
    ),
    dataIndex: 'employees',
    key: 'employees',
    align: 'center',
    width: '150',
    className: 'collapse-employee',
    render: (text, record, index) => checkIcon(text),
  },
  {
    title: (
      <Tooltip title={<>Sales</>} placement="bottomRight">
        Sales
      </Tooltip>
    ),
    dataIndex: 'sales',
    key: 'sales',
    width: '150',
    align: 'center',
    className: 'collapse-salse',
    render: (text, record, index) => checkIcon(text),
  },
];

export const expandColumns = [
  {
    title: (
      <div style={{ display: 'flex', alignItem: 'center' }}>
        <Tooltip title={<>Legal Entity</>} placement="bottomRight">
          Legal Entity
        </Tooltip>
        <Tooltip
          title={
            <div className="subs-table-tooltip-icon ">
              <div>
                <span className="appkiticon icon-radio-outline a-font-10 a-text-orange" />
                Subsidiary
              </div>
              <div>
                <span className="appkiticon icon-radio-fill a-font-10 a-text-orange" />
                Principal Subsidiary
              </div>
            </div>
          }
          placement="right"
        >
          <span className="appkiticon  a-font-12 ml-5 icon-information-fill" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'companyName',
    key: 'companyName',
    className: 'subsidiary-table-title',
    ellipsis: true,
    width: '400',
    sorter: (a, b) => sortAtoZ(a?.companyName, b?.companyName),
    render: (text, record, index) => {
      const { type, companyName } = record;
      const hasChildren = record.children && record.children.length !== 0;
      return (
        <Tooltip title={companyName}>
          {type === 'Subsidiary' && (
            <span
              className="appkiticon icon-radio-outline a-font-10 a-text-orange"
              style={{ margin: '0px 6px', opacity: hasChildren ? 1 : 0 }}
            />
          )}
          {type === 'Principal Subsidiary' && (
            <span
              className="appkiticon icon-radio-fill a-font-10 a-text-orange"
              style={{ margin: '0px 6px', opacity: hasChildren ? 1 : 0 }}
            />
          )}
          {companyName || '-'}
        </Tooltip>
      );
    },
  },
  {
    title: (
      <Tooltip title={<>Type</>} placement="bottomRight">
        Type
      </Tooltip>
    ),
    dataIndex: 'type',
    key: 'type',
    className: 'subsidiary-table-title subsidiary-table-type',
    ellipsis: true,
    width: '230',
    sorter: (a, b) => sortAtoZ(a.type, b.type),

    render: (text) =>
      text ? (
        <Tooltip title={text}>
          <span>{text}</span>
        </Tooltip>
      ) : (
        '-'
      ),
  },
  {
    title: (
      <Tooltip title={<>DUNS</>} placement="bottomRight">
        DUNS
      </Tooltip>
    ),
    dataIndex: 'duns',
    className: 'subsidiary-table-title subsidiary-table-duns',
    key: 'duns',
    ellipsis: true,
    width: '200',
    sorter: (a, b) => a.duns - b.duns,

    render: (text) =>
      text ? (
        <Tooltip title={text}>
          <span>{text}</span>
        </Tooltip>
      ) : (
        '-'
      ),
  },
  {
    title: (
      <Tooltip title={<>Location</>} placement="bottomRight">
        Location
      </Tooltip>
    ),
    dataIndex: 'completeLoc',
    className: 'subsidiary-table-title subsidiary-table-location',
    key: 'completeLoc',
    width: '200',
    align: 'left',
    ellipsis: true,
    sorter: (a, b) => sortAtoZ(a.completeLoc, b.completeLoc),

    filtered: false,
    render: tooltipCellRender,
  },
  {
    title: (
      <Tooltip title={<>Employees</>} placement="bottomRight">
        Employees
      </Tooltip>
    ),
    dataIndex: 'employees',
    className: 'subsidiary-table-title subsidiary-table-employees',
    key: 'employees',
    ellipsis: true,
    width: '200',
    sorter: (a, b) => a.employees - b.employees,
    render: (text) => {
      const newText = number_format(text);
      return text ? (
        <Tooltip title={newText}>
          <span>{newText}</span>
        </Tooltip>
      ) : (
        '-'
      );
    },
  },
  {
    title: (
      <Tooltip title={<>Sales($ ‘000S)</>} placement="bottomRight">
        Sales($ ‘000S)
      </Tooltip>
    ),
    className: 'subsidiary-table-title subsidiary-table-sales',
    dataIndex: 'sales',
    key: 'sales',
    width: '330',
    align: 'right',
    ellipsis: true,
    sorter: (a, b) => a.sales - b.sales,
    render: (text, item) => {
      const newText = text && number_format(text / 1000, 0);
      return text ? (
        <Tooltip title={text}>
          <span>${newText}</span>
        </Tooltip>
      ) : (
        '-'
      );
    },
  },
  {
    title: (
      <Tooltip title={<>Overlapping Location</>} placement="bottomRight">
        Overlapping Location
      </Tooltip>
    ),
    className: 'subsidiary-table-title',
    dataIndex: 'share',
    key: 'share',
    width: '150',
    align: 'center',
    ellipsis: true,
    render: (text, item) =>
      // const newText = text ? 'Y' : '';
      text ? <span className="appkiticon icon-check-mark-outline" /> : '',
  },
];

export const officeExpandColumns = [
  {
    title: 'Country',
    dataIndex: 'countryName',
    key: 'countryName',
    className: 'subsidiary-table-title',
    ellipsis: true,
    width: '15%',
    align: 'left',
    sorter: (a, b) => sortAtoZ(a.countryName, b.countryName),
    render: (companyName, record) => {
      const { hq } = record;
      return (
        <Tooltip title={companyName}>
          {hq ? (
            <span className="appkiticon icon-location-fill a-font-14 a-text-orange location-icon" />
          ) : (
            <span className="padding-span" />
          )}
          {companyName || '-'}
        </Tooltip>
      );
    },
  },
  {
    title: 'State',
    dataIndex: 'state',
    // className: 'subsidiary-table-title subsidiary-table-location',
    key: 'state',
    width: '15%',
    align: 'left',
    ellipsis: true,
    sorter: (a, b) => sortAtoZ(a.state, b.state),
    render: tooltipCellRender,
  },
  {
    title: 'City',
    dataIndex: 'city',
    // className: 'subsidiary-table-title subsidiary-table-location',
    key: 'city',
    width: '15%',
    align: 'left',
    ellipsis: true,
    sorter: (a, b) => sortAtoZ(a.city, b.city),
    render: tooltipCellRender,
  },
  {
    title: 'Zipcode',
    dataIndex: 'zipCode',
    // className: 'subsidiary-table-title subsidiary-table-location',
    key: 'zipCode',
    width: '15%',
    align: 'left',
    ellipsis: true,
    sorter: (a, b) => sortAtoZ(a.zipCode, b.zipCode),
    render: tooltipCellRender,
  },
  {
    title: 'Address',
    dataIndex: 'address',
    // className: 'subsidiary-table-title subsidiary-table-location',
    key: 'address',
    width: '25%',
    align: 'left',
    ellipsis: true,
    sorter: (a, b) => sortAtoZ(a.address, b.address),
    //TODO
    render: (text) => (
      <Tooltip title={text} placement="topRight">
        {text ? text : '-'}
      </Tooltip>
    ),
  },
  {
    title: 'Overlapping Location',
    dataIndex: 'share',
    key: 'share',
    width: '15%',
    align: 'center',
    ellipsis: true,
    render: (text, item) =>
      text ? <span className="appkiticon icon-check-mark-outline" /> : '',
  },
];

export const officeDefaultColumns = officeExpandColumns.filter((i) =>
  ['countryName', 'address'].includes(i.dataIndex),
);
